export class MultipleCheckboxService {
    private items: string[] = [];
    private totalItemsCount = 0;

    constructor(
        private enableImportBtn: () => void,
        private prefix: string, // Dynamic prefix for item IDs
        private selectAllId: string = 'selectAll-checkbox' // The ID of the "select-all" checkbox
    ) {}

    /** Initializes or updates the items list when feeds change */
    initializeItems($feeds: any[]) {
        this.totalItemsCount = $feeds.length;

        // Generate valid item IDs from the new feeds
        const validItemIds = $feeds.map((_, index) => `${this.prefix}${index}`);

        // Update items to include only those still valid and checked
        this.items = this.items.filter(itemId => validItemIds.includes(itemId));

        // Update the DOM checkboxes
        validItemIds.forEach(itemId => {
            const itemCheckbox = document.getElementById(itemId) as HTMLInputElement;
            if (itemCheckbox) {
                itemCheckbox.checked = this.items.includes(itemId); // Check if this item is selected
            }
        });

        this.updateSelectAllCheckbox();
        this.enableImportBtn();
    }

    /** Updates selected items and the "select-all" checkbox */
    updateItems(ids: string[]) {
        this.items = ids;
        this.updateSelectAllCheckbox();
        this.enableImportBtn();
    }

    /** Adds a single item to the selection */
    addItem(id: string) {
        if (!this.items.includes(id)) {
            this.updateItems([...this.items, id]);
        }
    }

    /** Removes a single item from the selection */
    removeItem(id: string) {
        if (this.items.includes(id)) {
            this.updateItems(this.items.filter(itemId => itemId !== id));
        }
    }

    /** Clears all selections */
    removeAll() {
        this.items.forEach(itemId => {
            const itemCheckbox = document.getElementById(itemId) as HTMLInputElement;
            if (itemCheckbox) itemCheckbox.checked = false;
        });
        this.updateItems([]);
    }

    /** Selects all items */
    selectAll($feeds: any[]) {
        this.items = $feeds.map((_, index) => `${this.prefix}${index}`);
        this.items.forEach(itemId => {
            const itemCheckbox = document.getElementById(itemId) as HTMLInputElement;
            if (itemCheckbox) itemCheckbox.checked = true;
        });
        this.setSelectAllCheckbox(true);
        this.enableImportBtn();
    }

    /** Returns all selected items */
    getSelectedItems() {
        return this.items;
    }

    /** Updates the "select-all" checkbox based on the current selection */
    private updateSelectAllCheckbox() {
        const allCheckbox = document.getElementById(this.selectAllId) as HTMLInputElement;
        if (allCheckbox) {
            const allSelected = this.items.length === this.totalItemsCount && this.areAllItemsChecked();
            allCheckbox.checked = allSelected;
            allCheckbox.indeterminate = this.items.length > 0 && this.items.length < this.totalItemsCount;
        }
    }

    /** Checks if all individual checkboxes are checked */
    private areAllItemsChecked(): boolean {
        return this.items.every(itemId => {
            const itemCheckbox = document.getElementById(itemId) as HTMLInputElement;
            return itemCheckbox && itemCheckbox.checked;
        });
    }

    /** Sets the "select-all" checkbox state */
    private setSelectAllCheckbox(checked: boolean) {
        const allCheckbox = document.getElementById(this.selectAllId) as HTMLInputElement;
        if (allCheckbox) allCheckbox.checked = checked;
    }
}
